export default "__VITE_ASSET__CYqpCM1w__"